import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef
} from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Tabs from 'devextreme-react/tabs';
import ScrollView from 'devextreme-react/scroll-view';
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import { formatMessage } from 'devextreme/localization';
import { LoadPanel } from 'devextreme-react/load-panel';
import Layout from '../../containers/Layout';
import style from './tablist.module.scss';
import PopupErrorMVP from '../../components/PopupErrorMVP';
import ModalContainer from '../../containers/ModalContainer';
import StockTabPanel from '../../containers/StockTabPanel/StockTabPanel';
import StockTabPanelConsignment from '../../containers/StockTabPanel/StockTabPanelConsignment';
import StockTabPanelRecycling from '../../containers/StockTabPanel/StockTabPanelRecycling';
import { getLocale, sortTabListByStockType } from '../../utils/functions';
import * as dayjs from 'dayjs';

function removeFunction(myObjects, prop, value) {
  return myObjects.filter((val) => val[prop] !== value);
}

const getStringWidth = (str) => {
  let strWidth = 0;

  strWidth += (str.match(/[А-ЯA-Z]/g) || []).length * 13;
  strWidth += (str.match(/[а-яa-z]/g) || []).length * 10;
  strWidth += (str.match(/-/g) || []).length * 5;
  strWidth += (str.match(/[()]/g) || []).length * 7;
  strWidth += (str.match(/ /g) || []).length * 7;
  strWidth += (str.match(/[.]/g) || []).length * 5;
  strWidth += (str.match(/"/g) || []).length * 5;

  return strWidth;
};

const TabList = ({
  reportReducer: { reportType },
  settingsReducer: { settings },
  stockReducer: {
    error,
    listStocks,
    loading,
    stockOptions
  },
  userReducer: {
    id,
    permissions,
    userInfo,
    userInfoError,
    userInfoStatus
  },
  fetchStock,
  fetchStockOptions,
  getReportTypes,
  getSettingsPlant,
  history,
  match,
  plantVisit,
  selectPlantId,
  setSelectTab,
  userGetInfo,
  userGetInfoClear,
  userGetPermissions
}) => {
  const dropDownBoxStock = useRef(null);
  const [getStockSelect, setGetStockSelect] = useState({});
  const [tabsListState, setTabsListState] = useState([
    {
      id: 0,
      text: formatMessage('textTabListMetalAvailable')
    },
    {
      id: 1,
      text: formatMessage('textTabListMetalReport')
    }
  ]);

  /** Выбор вкладки по умолчанию */
  const [tabSelectState, setTabSelectState] = useState(0);
  const [currentNode, setCurrentNode] = useState(null);
  const [checkTabSelectState, setCheckTabSelectState] = useState(true);

  useEffect(() => {
    setSelectTab(tabSelectState);
  }, [setSelectTab, tabSelectState]);

  /** если нет инфы про пользователя, запрашиваем через userGetInfo
   * и если вернулся userInfoStatus, то редирект на страницу с авторизацией */
  useEffect(() => {
    if (userInfo === null) {
      userGetInfo();
    }
    if (userInfoError === ''
      || userInfoStatus === 401
      || userInfoStatus === 403) {
      window.localStorage.setItem('redirectTime', dayjs(new Date().toLocaleString('en-US')).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'));
      history.push('/');
    }
  }, [userInfo, history, userInfoError, userInfoStatus, userGetInfo]);

  // useEffect(() => {
  //   if (userInfo === false) {
  //     document.location.href = '/';
  //   }
  // }, [userInfo]);

  useEffect(() => {
    if (error) {
      history.push('/');
    }
  }, [history, error]);

  useEffect(() => {
    if (!!userInfo) {
      getSettingsPlant({ plant: match.params.stockId });
      fetchStockOptions({ plantId: match.params.stockId });
    }
  }, [
    userInfo,
    getSettingsPlant,
    match.params.stockId,
    fetchStockOptions
  ]);

  useEffect(() => {
    if (id === null) return;
    if (!listStocks.length) {
      fetchStock({ id });
    } else if (Object.keys(settings).length) {
      setGetStockSelect(listStocks.filter(
        (e) => String(e.plantId) === match.params.stockId
      )[0]);
      window.localStorage.setItem('shippingType', listStocks.filter(
        (e) => String(e.plantId) === match.params.stockId
      )[0].shippingType);
      userGetPermissions({ plantId: match.params.stockId });
      selectPlantId(match.params.stockId);
    }
  }, [
    fetchStock,
    id,
    listStocks,
    match,
    stockOptions,
    userGetPermissions,
    selectPlantId,
    settings
  ]);

  useEffect(() => {
    if (match.params.stockId) {
      plantVisit({ plantId: match.params.stockId });
    }
  }, [match.params.stockId, plantVisit]);

  useEffect(() => {
    const savedTabSelect = Number(window.localStorage.getItem('tabSelect'));
    if (savedTabSelect && tabsListState.map((item) => item.id).includes(savedTabSelect)) {
      setTabSelectState(savedTabSelect);
    } else {
      setTabSelectState(0);
    }
  }, [tabsListState]);

  // todo Переделать выбор вкладки
  const isRecyclingOrdersEnabled = getStockSelect
  && Object.keys(getStockSelect).length
  && getStockSelect.showReports
  && getStockSelect.shippingType === 2
  && ((settings.executorIdSap
      && settings.executorIdSap.length)
    || (settings.stockType
      && settings.stockType === 'semi'));

  const isReadyStock = settings.stockType
    && Object.keys(settings.stockType).length
    && settings.stockType === 'ready';

  const isSemiStock = settings.stockType
    && Object.keys(settings.stockType).length
    && settings.stockType === 'semi';

  /** 0 - Наличие металла
   *  1 - Получение металла
   *  2 - Отчеты
   *  3 - Метрики по складу
   *  4 - Сканирование -- временно отключили по просьбе Саблиной Алевтины
   *  5 - Ответственные лица
   *  6 - Редактирование актов
   *  7 - Заказы на переработку
   *  8 - Производство
   *  9 - Балансировка отходов
   * 10 - Задания
   * 11 - Заказы
   * 12 - Работа с ТН
   * 13 - Инструкции для пользователей */
  useEffect(() => {
    let temp = [
      {
        id: 0,
        text: formatMessage('textTabListMetalAvailable')
      },
      {
        id: 1,
        text: formatMessage('textTabListMetalReport')
      }
    ];

    const reportsTab = {
      id: 2,
      text: formatMessage('textTabListReports')
    };

    // const stockMetricsTab = {
    //   id: 3,
    //   text: formatMessage('textTabListStockMetrics')
    // };

    const scanningTab = {
      id: 4,
      text: formatMessage('textTabListScanning')
    };

    const recyclingOrders = {
      id: 7,
      text: formatMessage('textTabRecyclingOrders')
    };

    const productionTab = {
      id: 8,
      text: formatMessage('textTabListProduction')
    };

    const wasteBalancing = {
      id: 9,
      text: formatMessage('textTabListWasteBalancing')
    };

    const taskTab = {
      id: 10,
      text: formatMessage('textTabTasks')
    };

    /** Дополнительная вкладка "Производство" для:
     *                                      Для склада одного из типов: ПФ/ГП
     *  Дополнительная вкладка "Заказы на переработку" для складов:
     *                                      7397 - БТЗ(переработка),
     *                                      8005 - КамаТрейд ПФ (ПМ),
     *                                      8086 - НПО БЬЕФ ПФ (ПМ),
     *                                      8164 - ИМЗ,
     *                                      Для склада типа ПФ,
     *  Дополнительная вкладка "Заказы" для складов переработчиков (для useSZWorking).
     * */

    let responsiblePersonTab = null;
    if (
      permissions
      && permissions.length
      && (permissions.indexOf('btnSesAdmin') !== -1
        || permissions.indexOf('btnUserAdmin') !== -1)
    ) {
      responsiblePersonTab = {
        id: 5,
        text: formatMessage('textTabListResponsiblePersons')
      };
    }
    let editActTab = null;
    if (
      permissions
      && permissions.length
      && (permissions.indexOf('btnSesAdmin') !== -1
        || permissions.indexOf('btnUserAdmin') !== -1
        || permissions.indexOf('prmEditAct') !== -1)
    ) {
      editActTab = {
        id: 6,
        text: formatMessage('textTabListEditAct')
      };
    }
    if (settings.stockType) {
      temp.unshift(productionTab);
    }

    let messagesAdminTab = null;

    if (
      permissions
      && permissions.length
      && permissions.indexOf('prm1cMon') !== -1
      && settings.clientId
    ) {
      messagesAdminTab = {
        id: 13,
        text: 'Интеграция'
      };
    }

    const salesOrders = {
      id: 11,
      text: formatMessage('textTabSO')
    };
    if (settings.useSZWorking) {
      temp.push(salesOrders);
    }

    const editTtnTab = {
      id: 12,
      text: formatMessage('textTabEditTtn')
    };

    if (isRecyclingOrdersEnabled) {
      temp.unshift(recyclingOrders);
      if (settings.stockType && settings.stockType === 'semi') {
        temp.unshift(taskTab);
        temp.unshift(wasteBalancing);
      }
    }
    if (isReadyStock) {
      temp = removeFunction(temp, 'id', 1);
    }

    if (
      getStockSelect
      && Object.keys(getStockSelect).length
      && (getStockSelect.showReports
        || getStockSelect.shippingType === 0
        || getStockSelect.shippingType === 1)
    ) {
      setTabsListState(() => {
        const ddtabs = temp.slice();
        ddtabs.push(reportsTab);
        ddtabs.push(scanningTab);
        // if (!settings.isOffBalanceSheet) {
        //   ddtabs.push(stockMetricsTab);
        // }
        if (messagesAdminTab) {
          ddtabs.push(messagesAdminTab);
        }
        if (responsiblePersonTab) {
          ddtabs.push(responsiblePersonTab);
        }
        if (editActTab) {
          ddtabs.push(editActTab);
        }
        if (settings.useTtnCreate && getStockSelect.shippingType === 0) {
          ddtabs.push(editTtnTab);
        }
        return ddtabs;
      });
    } else {
      setTabsListState(() => {
        const ddtabs = temp.slice();
        // ddtabs.push(stockMetricsTab);
        ddtabs.push(scanningTab);
        if (responsiblePersonTab) {
          ddtabs.push(responsiblePersonTab);
        }
        if (editActTab) {
          ddtabs.push(editActTab);
        }
        if (settings.useTtnCreate && getStockSelect.shippingType === 0) {
          ddtabs.push(editTtnTab);
        }
        if (messagesAdminTab) {
          ddtabs.push(messagesAdminTab);
        }
        return ddtabs;
      });
    }

    setTabsListState((prevState) =>
      sortTabListByStockType(
        prevState,
        getStockSelect.shippingType === 2 && settings.stockType === 'semi',
        getStockSelect.shippingType === 2 && settings.stockType === 'ready',
        getStockSelect.shippingType === 1,
        getStockSelect.shippingType === 0
      ));
  }, [
    getStockSelect,
    match.params.stockId,
    permissions,
    settings,
    isRecyclingOrdersEnabled,
    isReadyStock
  ]);

  useEffect(() => {
    setCheckTabSelectState((c) => !c);
  }, [permissions]);

  useEffect(() => {
    if (
      window.localStorage.getItem('tabSelect')
      && checkTabSelectState
      && tabsListState.length > 2
      && !tabsListState.find(
        (item) => item.id === Number(window.localStorage.getItem('tabSelect'))
      )
    ) {
      setTabSelectState(0);
    }
  }, [tabsListState, checkTabSelectState]);

  // useEffect(() => {
  //   if (currentNode) {
  //     console.log(currentNode);
  //   }
  // }, [currentNode]);

  const isUseM4 = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useM4;
  // }
  // return false;

    stockOptions.useM4 || false,
  [stockOptions]);

  /** Использовать принцип FIFO при выкупе запасов со склада */
  const isUseFIFO = useMemo(() =>
    // if (stockOptions && stockOptions.length > 0) {
    //   return stockOptions.useFIFO;
    // }
    // return false;
    stockOptions.useFIFO || false,
  [stockOptions]);

  /** Использовать акт о завершении хранения вместо МХ-3 */
  const isUseAZH = useMemo(() =>
    // if (stockOptions && stockOptions.length > 0) {
    //   return stockOptions.useAZH;
    // }
    // return false;
    stockOptions.useAZH || false,
  [stockOptions]);
  //
  // /** Использовать M-15 вместо МХ-1 */
  // const isUseM15Incoming = useMemo(() => {
  //   if (listStocks && match.params.stockId && listStocks.length > 0) {
  //     return listStocks.filter(
  //       (item) => item.plantId === Number(match.params.stockId)
  //     )[0].useM15Incoming;
  //   }
  //   return false;
  // }, [listStocks, match.params.stockId]);

  /** Использовать M15B вместо МХ-3 */
  const isUseM15B = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useM15B;
  // }
  // return false;

    stockOptions.useM15B || false,
  [stockOptions]);

  /** Использовать запрет на отгрузку заказа */
  const isUseProhibitionShipping = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useProhibitionShipping;
  // }
  // return false;

    stockOptions.useProhibitionShipping || false,
  [stockOptions]);

  const isAutoAcceptIncoming = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.autoAcceptIncoming;
  // }
  // return false;

    stockOptions.autoAcceptIncoming || false,
  [stockOptions]);

  /** Является ли склад хабом */
  const isHub = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.isHub;
  // }
  // return false;

    stockOptions.isHub || false,
  [stockOptions]);

  /** Отображать поле "Номер фрахтового заказа" */
  const showTranspOrder = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.showTranspOrder;
  // }
  // return false;

    stockOptions.showTranspOrder || false,

  [stockOptions]);

  /** Использовать СДЕ при создании МХ-3 */
  const isUseBuyer = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useBuyer;
  // }
  // return false;

    stockOptions.useBuyer || false,
  [stockOptions]);

  /** Не использование контейнеров при отгрузке */
  const isNotUseShippingContainer = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.notUseShippingContainer;
  // }
  // return false;

    stockOptions.notUseShippingContainer || false,
  [stockOptions]);

  /** Использование только № ТС и даты фактической отгрузки */
  const isUseShippingVehicleOnly = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useShippingVehicleOnly;
  // }
  // return false;

    stockOptions.useShippingVehicleOnly || false,
  [stockOptions]);

  /** Использовать блокировку на создание акта мх-3 и АЗХ если:
   * в акт добавлены УЕ с разными адресами грузополучателя */
  const isUseCheckShipToAddress = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useCheckShiptoAddress;
  // }
  // return false;

    stockOptions.useCheckShiptoAddress || false,
  [stockOptions]);

  /** Отгрузка/выкуп ГП по ТН со складов ОХ/переработчиков */
  const isUseBuyoutWithTtn = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useBuyoutWithTtn;
  // }
  // return false;

    stockOptions.useBuyoutWithTtn || false,
  [stockOptions]);

  /** Требуется прикрепить ТН */
  const isTtnAttachmentRequired = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.ttnAttachmentRequired;
  // }
  // return false;

    stockOptions.ttnAttachmentRequired || false,
  [stockOptions]);

  /** Использовать МХ для экспедиторов Колпино */
  const isUseMhOnExpeditor = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   // eslint-disable-next-line max-len
  //   return stockOptions.useMhOnExpeditor;
  // }
  // return false;

    stockOptions.useMhOnExpeditor || false,
  [stockOptions]);

  /** Использовать проверку кредитных лимитов при формировании МХ-3 */
  const isUseCreditLimitCheck = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useCreditLimitCheck;
  // }
  // return false;

    stockOptions.useCreditLimitCheck || false,
  [stockOptions]);

  /** Использовать проверку допустимой дебиторской задолженности при формировании МХ-3 */
  const isUseDZCheck = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useDZCheck;
  // }
  // return false;

    stockOptions.useDZCheck || false,
  [stockOptions]);

  /** Использовать проверку просроченной дебиторской задолженности при формировании МХ-3 */
  const isUsePDZCheck = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.usePDZCheck;
  // }
  // return false;

    stockOptions.usePDZCheck || false,
  [stockOptions]);

  /** Вес с производства по фактическому весу */
  const useFactWeight = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useFactWeight;
  // }
  // return false;

    stockOptions.useFactWeight || false,
  [stockOptions]);

  /** Настройка Производства ЛГ (Лишний годный) */
  const useProductionLg = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useProductionLg;
  // }
  // return false;

    stockOptions.useProductionLg || false,
  [stockOptions]);

  /** Формировать СК при отгрузке (для переработчиков) */
  const useQcGenerationShipment = useMemo(() =>
  // if (stockOptions && stockOptions.length > 0) {
  //   return stockOptions.useQcGenerationShipment;
  // }
  // return false;
    stockOptions.useQcGenerationShipment || false,
  [stockOptions]);

  /** Включена ли функция создания ТН */
  const isUseTtnCreate = useMemo(() => {
    if (listStocks && match.params.stockId && listStocks.length > 0) {
      return listStocks.filter(
        (item) => item.plantId === Number(match.params.stockId)
      )[0].useTtnCreate;
    }
    return false;
  }, [listStocks, match.params.stockId]);
  //
  // /** Расположение рулонов в кузове авто */
  // const isUsePlacingRollsInCarBody = useMemo(() => {
  //   if (listStocks && match.params.stockId && listStocks.length > 0) {
  //     return listStocks.filter(
  //       (item) => item.plantId === Number(match.params.stockId)
  //     )[0].usePlacingRollsInCarBody;
  //   }
  //   return false;
  // }, [listStocks, match.params.stockId]);
  //
  // /** Доступность выбора зон и боксов при приёмке */
  // const isUseStorageLevels = useMemo(() => {
  //   if (listStocks && match.params.stockId && listStocks.length > 0) {
  //     return listStocks.filter(
  //       (item) => item.plantId === Number(match.params.stockId)
  //     )[0].useStorageLevels;
  //   }
  //   return false;
  // }, [listStocks, match.params.stockId]);

  /** Список главных вкладок в верхней части окна */
  const ItemTabs = useMemo(() => () => (
    <Tabs elementAttr={{ id: style.tabsItem }}
          items={tabsListState.filter((item) => !(item.id === 1 && settings.autoAcceptIncoming))}
          selectedItem={
            tabsListState
              .filter((item) => !(item.id === 1 && settings.autoAcceptIncoming))
              .filter((item) => item.id === tabSelectState)[0]
          }
          onItemClick={(args) => {
            window.localStorage.setItem('tabSelect', args.itemData.id);
            setTabSelectState(args.itemData.id);
          }}
    />
  ), [tabSelectState, setTabSelectState, tabsListState, settings]);

  /** Выбор склада */
  const onItemSelectionChanged = useCallback(({ node }) => {
    localStorage.setItem('plantId', node.itemData.plantId);
    setCurrentNode(node);
    document.location = `/tablist/${node.itemData.plantId}`;
    // dropDownBoxStock.current.instance.close();
  }, [setCurrentNode]);

  const scrollTreeList = useCallback(() => {
    if (
      dropDownBoxStock.current
      && dropDownBoxStock.current.instance
      && dropDownBoxStock.current.instance._scrollableContainer
      && currentNode
    ) {
      dropDownBoxStock.current.instance._scrollableContainer.scrollToElement(
        currentNode
      );
    }
  }, [currentNode]);

  const TreeListStocks = useCallback(
    () => (
      <TreeView
        ref={dropDownBoxStock}
        dataSource={listStocks}
        dataStructure="plain"
        keyExpr="plantId"
        selectionMode="single"
        displayExpr="plantShortDescr"
        selectByClick
        searchMode="contains"
        searchEnabled
        onContentReady={() => {}}
        onItemSelectionChanged={onItemSelectionChanged}
        onInitialized={scrollTreeList}
      />
    ),
    [listStocks, onItemSelectionChanged, scrollTreeList]
  );

  useEffect(() => {
    if (getStockSelect.plantShortDescr) {
      if (getLocale() === 'ru') {
        document.title = `${getStockSelect.plantShortDescr} | Северсталь-Инфоком | Типовой удаленный склад`;
      } else {
        document.title = `${getStockSelect.plantShortDescr} | Severstal-Infocom | Typical Remote Stockyard`;
      }
    }
  }, [getStockSelect.plantShortDescr]);

  /** Выпадающий список складов */
  const ItemStocksNew = useCallback(
    () => (
      <div className={style.itemSelectStock}>
        <span>{`${formatMessage('textTabListStock')}:`}</span>
        <DropDownBox
          ref={dropDownBoxStock}
          elementAttr={{ class: style.stockButton }}
          displayExpr="plantShortDescr"
          valueExpr="plantId"
          value={getStockSelect.plantShortDescr}
          placeholder={formatMessage('loading')}
          stylingMode="underlined"
          width={getStockSelect.plantShortDescr ? `${Math.max(200, getStringWidth(getStockSelect.plantShortDescr))}px` : 'auto'}
          dataSource={listStocks}
          contentRender={TreeListStocks}
        />
      </div>
    ),
    [TreeListStocks, getStockSelect, listStocks]
  );

  const getOnHiding = useCallback(() => {
    userGetInfoClear();
    history.push('/');
  }, [history, userGetInfoClear]);

  const toolbarRender = useMemo(
    () => (
      <Toolbar elementAttr={{ class: style.toolbar }}>
        <Item location="center" render={ItemTabs} />
      </Toolbar>
    ),
    [ItemTabs]
  );

  return (
    <Layout shippingType={getStockSelect.shippingType}>
      <div className={style.containing}>
        <div className={style.head}>
          <ItemStocksNew />
          <ScrollView
            scrollByContent
            scrollByThumb
            direction="horizontal"
            showScrollbar="always"
            height={52}
            width="calc(100vw - 300px)"
          >
            <div style={{ height: '52px' }}>{toolbarRender}</div>
          </ScrollView>
        </div>
        <div className={style.main}>
          {(
            // eslint-disable-next-line no-nested-ternary
            getStockSelect.shippingType === 1
              ? (
                <StockTabPanelConsignment isAutoAcceptIncoming={isAutoAcceptIncoming}
                                          isHub={isHub}
                                          isUseCheckShiptoAddress={isUseCheckShipToAddress}
                                          isUseAZH={isUseAZH}
                                          isUseFIFO={isUseFIFO}
                                          isUseM4={isUseM4}
                                          plantId={match.params.stockId}
                                          showTranspOrder={showTranspOrder}
                                          tabsListState={tabsListState}
                />
              )
              : (
                getStockSelect.shippingType === 2
                  ? (
                    <StockTabPanelRecycling isAutoAcceptIncoming={isAutoAcceptIncoming}
                                            isReadyStock={isReadyStock}
                                            isRecyclingOrdersEnabled={isRecyclingOrdersEnabled}
                                            isSemiStock={isSemiStock}
                                            isUseAZH={isUseAZH}
                                            isUseBuyoutWithTtn={isUseBuyoutWithTtn}
                                            isUseCheckShiptoAddress={isUseCheckShipToAddress}
                                            isUseM15B={isUseM15B}
                                            isUseM4={isUseM4}
                                            plantId={match.params.stockId}
                                            showTranspOrder={showTranspOrder}
                                            tabsListState={tabsListState}
                                            useFactWeight={useFactWeight}
                                            useProductionLg={useProductionLg}
                    />
                  )
                  : (
                    getStockSelect.shippingType === 0
                    && (
                      <StockTabPanel isAutoAcceptIncoming={isAutoAcceptIncoming}
                                     isOffBalanceSheet={settings.isOffBalanceSheet}
                                     isUseAZH={isUseAZH}
                                     isUseFIFO={isUseFIFO}
                                     isUseM4={isUseM4}
                                     isUseMhOnExpeditor={isUseMhOnExpeditor}
                                     isUseProhibitionShipping={isUseProhibitionShipping}
                                     isUseShippingVehicleOnly={isUseShippingVehicleOnly}
                                     plantId={match.params.stockId}
                                     showTranspOrder={showTranspOrder}
                                     tabsListState={tabsListState}
                      />
                    )
                  )
              )
            )}
        </div>
      </div>
      <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                 showPane
                 shading={false}
                 showIndicator
                 visible={loading}
      />
      <PopupErrorMVP visible={!!userInfoError
        && userInfoStatus
        && userInfoStatus !== 401
        && userInfoStatus !== 403}
                     message={userInfoError
                       ? !userInfoError.message
                         ? (userInfoStatus === 500)
                           ? formatMessage('textError').endSession
                           : (userInfoStatus === 503)
                             ? formatMessage('textError').serviceUnavailable
                             : formatMessage('textError').unknownError
                         : userInfoError.message
                       : formatMessage('textError').endSession}
                     techInfo={(!userInfoError.techInfo)
                       ? `${formatMessage('textSupportPhone')} 8-800-200-69-39`
                       : userInfoError.techInfo}
                       onHiding={getOnHiding}
                       width={'600'}
                       types="info"
      />
      <ModalContainer isHub={isHub}
                      isNotUseShippingContainer={isNotUseShippingContainer}
                      isOffBalanceSheet={settings.isOffBalanceSheet}
                      isReadyStock={isReadyStock}
                      isTtnAttachmentRequired={isTtnAttachmentRequired}
                      isUseBuyer={isUseBuyer}
                      isUseBuyoutWithTtn={isUseBuyoutWithTtn}
                      isUseCheckSeparation={settings.useCheckSeparation}
                      isUseCreditLimitCheck={isUseCreditLimitCheck}
                      isUseDZCheck={isUseDZCheck}
                      isUseMhOnExpeditor={isUseMhOnExpeditor}
                      isUseM4={isUseM4}
                      isUseM15B={isUseM15B}
                      isUsePDZCheck={isUsePDZCheck}
                      isUseShippingVehicleOnly={isUseShippingVehicleOnly}
                      isUseStorageLevels={settings.useStorageLevels}
                      isUseTtnCreate={isUseTtnCreate}
                      plantId={match.params.stockId}
                      printQcFromQmet={settings.printQcFromQmet}
                      printQcFromStorage={settings.printQcFromStorage}
                      shippingType={getStockSelect.shippingType}
                      useQcGenerationShipment={useQcGenerationShipment}
      />
    </Layout>
  );
};

export default React.memo(TabList);
